import api from '@/core/services/api';
import { toDrupalRequest } from '@/core/helpers';
import { startLatestRequest } from '@/core/latestRequest';

export default {
    async getValuationSummaryChartData({ commit, getters }, filter) {
        let chartDataEndpoint = '/valuation/summary/plantotals';

        const uuidArray = getters.policyUUIDArray;
        // we need to add the current policy string
        chartDataEndpoint += '/' + uuidArray.join(',');

        // add the date on if provided.
        if (filter.date) {
            chartDataEndpoint += '/' + filter.date;
        }

        const isLatest = startLatestRequest('valuationSummaryChartData');
        const response = await api.get(`${toDrupalRequest(chartDataEndpoint)}`);
        if (isLatest() && response) {
            commit('setValuationSummaryChartData', response);
        }
    },
    async getPolicyValuationSummaryChartData({ commit, getters }, filter) {
        let chartDataEndpoint = '/valuation/summary/policychart';

        chartDataEndpoint += '/' + getters.policySelected.value;

        if (filter.period) {
            chartDataEndpoint += '/' + filter.period;
        }

        // add the date on if provided.
        if (filter.date) {
            chartDataEndpoint += '/' + filter.date;
        }

        const isLatest = startLatestRequest('policyChartData');
        const response = await api.get(`${toDrupalRequest(chartDataEndpoint)}`);
        if (isLatest() && response) {
            commit('setPolicyChartData', response.chartData);
        }
    },
    async getValuationDocumentPresignedUrl(_, filter) {
        try {
            const date = filter.date ?? '';
            const portfolio = filter.portfolio ?? 'all';
            const people = Array.isArray(filter.people) && filter.people.length > 0 ? filter.people.join(',') : 'all';

            const endpoint = `/valuation/document?d=${date}&po=${portfolio}&pe=${people}`;
            const response = await api.get(toDrupalRequest(endpoint));

            return response?.Presigned ?? null;
        } catch (error) {
            console.error('Failed to fetch valuation document URL:', error);
            return null;
        }
    },
    setValuationDate({ commit }, value) {
        commit('setValuationDate', value);
    },
    // dateRange
    setDateRangeFrom({ commit }, value) {
        commit('setDateRangeFrom', value);
    },
    setDateRangeTo({ commit }, value) {
        commit('setDateRangeTo', value);
    },
    // Policy Holdings Dialogs
    setCurrentISIN({ commit, dispatch, state }, isin) {
        if (state.currentISIN !== isin) {
            commit('setCurrentISIN', isin);
            // reset data
            commit('resetFundDialogData');
            dispatch('getFundAllocationDialogData', isin);
        }
    },
    async getFundAllocationDialogData({ commit, getters }, data) {
        let valuationDate = getters.valuationDate;
        const response = await api.get(
            `${toDrupalRequest('assetallocation/fund/' + data.isin + '/' + valuationDate.format('YYYY-MM-DD'))}`
        );
        if (response) {
            commit('setFundAllocationDialogData', response);
        } else {
            commit('setFundAllocationDialogData', { error: true });
        }
    },
    // Benchmarks
    async setNewBenchmark({ dispatch }, data) {
        const response = await api.post(
            `${toDrupalRequest('valuation/portfolios/benchmark/' + data.portfolioId)}`,
            JSON.stringify(data.benchmark),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        if (response.benchmarkID) {
            // returns newly created benchmark id as a string
            dispatch('getPortfolioOptions', { force: true });
            return 'true';
        }
    },
    async updateBenchmark({ dispatch }, data) {
        const response = await api.patch(
            `${toDrupalRequest('valuation/portfolios/benchmark/' + data.portfolioId)}`,
            JSON.stringify(data.benchmark),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        if (response.success) {
            dispatch('getPortfolioOptions', { force: true });
            return 'true';
        }
    },
};
